import React, { useCallback, useEffect } from 'react';
import { Checkbox } from '@pwc/appkit-react/lib/Checkbox';
import { Option } from '../../shared/types/common';
import { StandardReportDefinition } from '../../shared/types/batchReports';
import { ParamValues } from '../../shared/types/customReports';
import { ReportRowParams } from './standardReportRowParams.component';
import { useReportParamsOptions } from './useReportParamsOptions';
import { DefaultReportValues } from './types';

type ReportRowProps = {
  reportName: string,
  reportType: string,
  reportLabel: string,
  reportDefinition: StandardReportDefinition,
  reportParamValues: ParamValues,
  isIncludedInExport: boolean,
  updateReportParamValues: (itemName: string, newParameters: ParamValues) => void
  updateIncludedInExport: (itemName: string, newParameters: boolean) => void,
  syncParamOptions: (reportName: StandardReportDefinition['reportName'], data: { options: Record<string, Option[]>, defaultValues: DefaultReportValues[string] }) => void;
  archivalFlag: boolean,
  restrictBatchDefaults: boolean,
  userRole:string,
  editable:boolean
};

export const StandardReportRow: React.FC<ReportRowProps> = ({
  reportName,
  reportLabel,
  reportDefinition,
  reportParamValues,
  isIncludedInExport,
  updateReportParamValues,
  updateIncludedInExport,
  syncParamOptions,
  archivalFlag,
  restrictBatchDefaults,
  userRole,
  editable,
}: ReportRowProps) => {
  const onCheckboxClick = useCallback(() => {
    updateIncludedInExport(reportDefinition.reportName, !isIncludedInExport);
  }, [
    updateIncludedInExport,
    reportDefinition,
    isIncludedInExport,
  ]);

  const {
    data: { options, defaultValues },
    isFetching: isLoading,
    refetch: refetchReportOptions,
  } = useReportParamsOptions({
    reportName,
    reportParamValues,
    onSuccess: data => syncParamOptions(
      reportName,
      { options: data.options || {}, defaultValues: data.defaultValues || {} }
    ),
  });
  const inputParameters = Object.values(reportParamValues || {}).join(',');

  // refetch only when inputParameters change
  useEffect(() => {
    refetchReportOptions();
  }, [refetchReportOptions, inputParameters]); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <div className="row no-gutters page-content-container">
      <div className="row no-gutters batch-report-name-header">
        <div className="batch-report-name-checkbox">
          <Checkbox
            onChange={onCheckboxClick}
            checked={isIncludedInExport}
            disabled={restrictBatchDefaults}
          >
            {reportLabel}
          </Checkbox>
        </div>
      </div>
      <div className="no-gutters batch-report-params-container">
        <ReportRowParams
          reportDefinition={reportDefinition}
          reportParamValues={reportParamValues}
          updateReportParamValues={updateReportParamValues}
          options={options}
          defaultValues={defaultValues}
          isLoading={isLoading}
          archivalFlag={archivalFlag}
          restrictBatchDefaults={restrictBatchDefaults}
          userRole={userRole}
          editable={editable}
        />
      </div>
    </div>
  );
};
